import { CHANGE_INPUT_RIVERINFO } from "../actions/actionTypes.js";

const initialState = {
  title: "",
  form: {
    area: {
      options: [{ value: "kiev", label: "Київська" }],
      name: "area",
      placeholder: "Область:",
      disabled: false,
    },
    rivers: {
      data: {
        kiev: [{ value: "dnipro", label: "Дніпро" }],
      },
      options: [],
      name: "river",
      placeholder: "Річка:",
      disabled: true,
      value: "",
    },
  },
  link: {
    icon: "info-circle",
    to: "/riverDiagram",
  },
  rivers: {
    dnipro: {
      name: "Дніпро",
      preview:
        "четверта за довжиною річка Європи після Волги, Дунаю і Уралу, має найдовше русло в межах України",
      informMiddle: `
        Найбільша річка в Україні і третя за величиною в Європі (після Волги
        та Дунаю).Дніпро займає 504 000 кв. Км, з них 289 000 кв. Км знаходиться в межах
        України (48 відсотків її площі). Басейн займає 42 відсотки території
        української держави та 36 відсотків української етнічної території.
        Дніпро - типова рівнинна рівнина, пологий похил і повільний потік.
        Рівень води значно коливається, а русло річки нестійке. Тут багато
        мілких частин, але поворотів порівняно мало. Дніпро - головна річкова мережа України. 
        Половина водних шляхів України належить до цієї системи. Майже 65 відсотків судноплавства
        (75 відсотків, якщо включено річку Десну та річку Прип'ять) та 80–90
        відсотків пасажирів перевозяться Дніпром. 
        Основними товарами є будівельні матеріали та цемент,
        антрацитове вугілля, залізна руда та марганцева руда;
        транспортуються також зерно, нафтопродукти та метали. `,
      inform: `Найбільша річка в Україні і третя за величиною в Європі (після Волги
        та Дунаю). З самого початку історії Дніпро був тісно пов'язаний з
        життям українського народу. Це «свята річка» України. Її довжина
        становить 2285 км, з них 485 км лежать в межах Російської Федерації,
        595 км в межах Білорусі та 1095 км в межах України. Басейн # Дніпро
        займає 504 000 кв. Км, з них 289 000 кв. Км знаходиться в межах
        України (48 відсотків її площі). Басейн займає 42 відсотки території
        української держави та 36 відсотків української етнічної території.
        Дніпро - типова рівнинна рівнина, пологий похил і повільний потік.
        Рівень води значно коливається, а русло річки нестійке. Тут багато
        мілких частин, але поворотів порівняно мало. Дніпровські пороги, які
        сьогодні занурені в воду, є особливою особливістю Дніпра.
        Загальний південний потік річки можна розбити на кілька ділянок: від
        витоку до Орші (Вітебська область) Дніпро тече на південний захід,
        потім на південь до Києва, потім на південний схід до Дніпра, потім
        на південь на 90 км до Запоріжжя і, нарешті, на південний захід до
        Дніпро-Бохського лиману. Таким чином, Дніпро утворює великий
        відкритий лук на схід, подвоюючи шлях від центральної України до
        Чорного моря (до 950 км, хоча Київ знаходиться лише 450 км від моря
        по прямій лінії). Ріку можна розділити на три ділянки: верхній
        Дніпро від витоку до Києва (1333 км, з них 255 км - в межах
        України); середній, від Києва до Запоріжжя (536 км), включаючи
        згаданий вище ділянку порогів; і нижній, від Запоріжжя до моря (331
        км).Дніпро - головна річкова мережа України. Половина водних шляхів
        України належить до цієї системи. Майже 65 відсотків судноплавства
        (75 відсотків, якщо включено річку Десну та річку Прип'ять) та 80–90
        відсотків пасажирів перевозяться Дніпром. У 1977 р. Дніпром було
        відвантажено понад 30 млн т вантажів. З економічними змінами та
        завершенням безперервного водного шляху характер судноплавства
        змінився. Основними товарами є будівельні матеріали та цемент,
        антрацитове вугілля, залізна руда та марганцева руда;
        транспортуються також зерно, нафтопродукти та метали.`,
      src: "images/dnipro.jpg",
      srcMapImg: "images/dnipro_map.png",
      pollutants: [
        {
          name: "Іони амонію",
          content: "0.3",
          measurer: "мг/дм3",
          data: "09/06/2020",
          danger: 5,
          max: 0.5,
        },
        {
          name: "БСК5",
          content: "2.9",
          measurer: "мг/дм3",
          data: "09/06/2020",
          danger: 2,
          max: 4.0,
        },
        {
          name: "Фосфат",
          content: "2.4",
          measurer: "мг/дм3",
          data: "09/06/2020",
          danger: 4,
          max: 3.5,
        },
        {
          name: "Хлорид",
          content: "270.6",
          measurer: "мг/дм3",
          data: "09/06/2020",
          danger: 7,
          max: 300.0,
        },
        {
          name: "ХСК",
          content: "4.2",
          measurer: "мг/дм3",
          data: "09/06/2020",
          danger: 2,
          max: 5.0,
        },
        {
          name: "Кисень",
          content: "9.0",
          measurer: "мг/дм3",
          data: "09/06/2020",
          danger: 2,
          max: 4.0,
        },
        {
          name: "Нітрат",
          content: "34.0",
          measurer: "мг/дм3",
          data: "09/06/2020",
          danger: 8,
          max: 40.0,
        },
        {
          name: "Нітрит",
          content: "0.05",
          measurer: "мг/дм3",
          data: "09/06/2020",
          danger: 7,
          max: 0.08,
        },
        {
          name: "Перманганат",
          content: "3.6",
          measurer: "мг/дм3",
          data: "09/06/2020",
          danger: 6,
          max: 5.0,
        },
        {
          name: "Сульфат",
          content: "220.0",
          measurer: "мг/дм3",
          data: "09/06/2020",
          danger: 4,
          max: 250.0,
        },
        {
          name: "Завислі речовини",
          content: "10.6",
          measurer: "мг/дм3",
          data: "09/06/2020",
          danger: 4,
          max: 15.0,
        },
      ],
    },
  },
};
export default function homeReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_INPUT_RIVERINFO:
      return { ...state, form: { ...action.form } };
    default:
      return state;
  }
}
